import apiClient from "./http";

export const getDashboardMetrics = () => apiClient.get("/Dashboard/metrics");

export const getDashboardNextActions = () =>
  apiClient.get("/Dashboard/next-actions");

export const logDashboardEvent = (payload) =>
  apiClient.post("/Dashboard/log-event", payload);
